import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)({
  padding: '6px 10px',
  '& .MuiButton-root': {
    fontSize: '14px',
    padding: '4px 8px',
    gap: 4,
    '& svg': {
      fontSize: '16px',
    },
  },
});

export default StyledBox;
